export default {
  ADMIN: 'admin',
  AUTHOR: 'author',
  TEACHER: 'teacher',
  STUDENT: 'student'
}



// WEBPACK FOOTER //
// ./src/misc/roles.js